<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원공지사항</span>
            <span class="txt">회원들에게 공지사항, 업데이트 등 여러 사항을 전달할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="!noticeList"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area"></div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 120px" />
                    <col style="width: 1000px" />
                    <col style="width: 205px" />
                    <col style="width: 205px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>등록일</th>
                        <th>제목</th>
                        <th>글쓴이</th>
                        <th>조회수</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(notice, index) in noticeList" :key="index">
                        <td>{{ notice.c_cre_dt | timestampFilter }}</td>
                        <td>
                            <router-link
                                :to="`/madmin/setting/member/notice/detail/${notice.c_center_borad_notice_id}/${notice.c_center_id}`"
                                class="ic-link"
                            >
                                <span class="ic">{{ notice.c_cate_nm }}</span>
                                <span
                                    :class="{
                                        txt: true,
                                        red: notice.c_top_fix_yn === true,
                                        new: newPost(notice.c_cre_dt),
                                    }"
                                >
                                    {{ notice.c_title }}
                                </span>
                            </router-link>
                        </td>
                        <!--                        <td>{{ notice.c_cre_nm }}</td>-->
                        <td>{{ notice.cs_namee }}</td>
                        <td>{{ notice.c_view_cnt }}</td>
                    </tr>
                    <tr v-if="noticeList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link v-if="isWriteAuth" class="com-btn blue" to="/madmin/setting/member/notice/edit">
                        글쓰기
                    </router-link>
                </div>
            </div>
        </div>
        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event)"
        ></b-pagination>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { calcNewPost } from '@/assets/js/validation.js';
import { pagingInfo } from '@/assets/js/common';
import {mapGetters} from 'vuex';

export default {
    name: 'SettingMemberNoticeList',
    props: {},
    computed: {
        ...mapGetters({
            cId: 'auth/cId',
        }),
        isWriteAuth() {
            const { getters } = this.$store;
            return (
                getters['auth/isCareAdmin'] ||
                getters['auth/isSystemAdmin'] ||
                getters['auth/isCenterAdmin'] ||
                getters['auth/isCenterStaff']
            );
        },
        isReadAuth() {
            const { getters } = this.$store;
            return this.isWriteAuth || getters['auth/isCustomer'];
        },
    },
    mounted() {
        this.noticeCenterId = parseInt(this.cId); // 센터 공지사항 centerId
        this.fetchNoticeList();
    },
    data() {
        return {
            noticeCenterId: '',
            noticeList: null,
            pagingInfo: { ...pagingInfo },
        };
    },

    methods: {
        // 최근 게시글(N) 표시 위한 날짜 계산, true면 새 게시글
        newPost(creDt) {
            return calcNewPost(creDt);
        },

        // 공지사항 목록 Fetch
        async fetchNoticeList() {
            try {
                const { data } = await this.getNoticeList();
                console.log('===> Success Load Center Notice List : ', data);
                this.setPageParams(data);
                this.noticeList = data.items;
            } catch (error) {
                console.log(error);
            }
        },

        // 공지사항 목록 조회 API 호출
        getNoticeList() {
            // 스웨거 검색: 센터 공지사항 생성
            return api.get(`/admin/api/center/${this.noticeCenterId}/board/notice`, {
                params: {
                    ...this.pagingInfo,
                },
            });
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.fetchNoticeList();
        },

        // 페이징 Param set
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
    },
};
</script>
<style lang="scss"></style>
